import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 27000-27999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const calendarErrors = {
  // 27xxx is the calendar module's series. Eleven of its 22 generic sites needed no new code at all:
  // six shipped "Schedule does not exist" (SCHEDULE_MISSING, 10002) and five used the shared
  // VERSION_IN_PROGRESS_MSG (SCHEDULE_VERSION_OPERATION_IN_PROGRESS, 10013). Five more stay generic,
  // forwarding a caught `error.message`.
  // 27001-27006 — the calendar module's split.
  CALENDAR_SAVE_FAILED: {
    errorCode: 27001,
    errorMessage: t("Calendar could not be saved."),
    isDynamic: false,
  },
  CALENDAR_NOT_FOUND_IN_SCHEDULE_VERSION: {
    errorCode: 27002,
    errorMessage: t("No calendar matched the ids in this schedule version."),
    isDynamic: false,
  },
  CALENDAR_DEFAULT_SET_FAILED: {
    errorCode: 27003,
    errorMessage: t("Default calendar could not be set."),
    isDynamic: false,
  },
  CALENDAR_TO_DUPLICATE_NOT_FOUND: {
    errorCode: 27004,
    errorMessage: t("No active calendar matched the ids to duplicate."),
    isDynamic: false,
  },
  CALENDAR_DUPLICATE_SAVE_FAILED: {
    errorCode: 27005,
    errorMessage: t("Duplicated calendars could not be saved."),
    isDynamic: false,
  },
  CALENDAR_FETCH_FAILED: {
    errorCode: 27006,
    errorMessage: t("Failed to fetch calendars"),
    isDynamic: false,
  },
  CALENDAR_STATUS_DATE_UNCHANGED: {
    errorCode: 27007,
    errorMessage: t("Status date was not updated."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
